/**
 * Sticky left menu — `.menu-container` + `.left-menu` + `.left-menu-btn`.
 * Port 1:1 din legacy common.js lines 2349-2408.
 *
 * Cand scroll-ul depaseste pozitia containerului, arata butonul flotant care
 * deschide left menu. La inchidere, ascunde butonul daca nu mai e sticky.
 *
 * Apelat doar pe viewports > 600px (legacy guard).
 */

import { $ } from '../core/selector.js';

export function initStickyMenu(): void {
    if (window.innerWidth <= 600) return;

    const nav = $('.menu-container') as HTMLElement | null;
    if (!nav) return;

    const leftMenu = $('.left-menu') as HTMLElement | null;
    const menuBtn  = $('.left-menu-btn') as HTMLElement | null;
    if (!leftMenu || !menuBtn) return;

    const navHomeY = nav.offset().top;
    let isFixed = false;
    let isLoaded = false;
    let menuHasOpen = false;

    let scrollTop = window.scrollY;
    let shouldBeFixed = scrollTop > navHomeY;

    if (isLoaded) return;
    isLoaded = true;

    if (shouldBeFixed) {
        isFixed = true;
        if (!menuHasOpen) menuBtn.style.display = 'block';
    }

    window.addEventListener('scroll', () => {
        scrollTop = window.scrollY;
        shouldBeFixed = scrollTop > navHomeY;
        if (shouldBeFixed && !isFixed) {
            isFixed = true;
            if (!menuHasOpen) menuBtn.style.display = 'block';
        } else if (!shouldBeFixed && isFixed) {
            isFixed = false;
            leftMenu.classList.remove('opened');
            menuHasOpen = false;
            menuBtn.style.display = 'none';
        }
    });

    menuBtn.on('click', function (this: Element) {
        (this as HTMLElement).style.display = 'none';
        menuHasOpen = true;
        leftMenu.classList.add('opened');
    });

    leftMenu.on('click', 'a.close-popup', function () {
        menuHasOpen = false;
        leftMenu.classList.remove('opened');
        if (isFixed) menuBtn.style.display = 'block';
    });
}
